import React from 'react'
import Button from '../../../../../../common/components/atom/Button/Button'
import { PenIcon } from '../../../../../../common/assets/icons'
import { useSinglePlanBT } from '../../../../hooks'
import { PermissionTooltip, useCapability } from '../../../../../rbac'

export default function UpdateBtnPresenter() {
const {singlePlanBTQuery:{data}} = useSinglePlanBT()
const canEdit = useCapability('planbt.edit')

    if (!data){
        return <></>
      }
      return (
            <PermissionTooltip allowed={canEdit}>
              <Button
            label="Modifier" 
            IconComponentLeft={() => <PenIcon />}
            linkTo={"/main/plan-bt/"+data?.plan_id+"/edit"}
            disabled={!canEdit}
            variant={"tercery"}/>
            </PermissionTooltip>
      )
  
}
